module.exports = __webpack_public_path__ + "img/bagi.1d1867ed.png";